import { forwardRef } from "react";

/**
 * Public KPI strip, mission and safety metrics, updated quarterly.
 * Deliberately not a growth vanity dashboard: what we measure signals what we protect.
 */
type Kpi = { value: string; label: string; note?: string };

const kpis: Kpi[] = [
  { value: "0", label: "user rows sold or shared with advertisers", note: "Ever. See Trust." },
  { value: "0", label: "medical claims made by the product", note: "Wellness tool, not a device." },
  { value: "48h", label: "security-report response SLA", note: "security@myelinahealth.com" },
  { value: "60d", label: "minimum data before we call a pattern real", note: "With 95% confidence bands." },
  { value: "<1min", label: "typical account-deletion propagation", note: "Every table, purged." },
  { value: "us-east-1", label: "single data residency region", note: "AWS. No cross-region shuffling." },
];

const PublicKpiStrip = forwardRef<HTMLElement>((_, ref) => (
  <section
    ref={ref}
    aria-label="Public KPIs"
    className="border-y border-border/60 bg-muted/30"
  >
    <div className="container mx-auto px-6 sm:px-10 lg:px-16 py-12">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-baseline justify-between mb-8 flex-wrap gap-3">
          <p className="text-[11px] tracking-[0.28em] uppercase text-muted-foreground">
            Public KPIs
          </p>
          <p className="text-xs text-muted-foreground">
            Updated quarterly. Last review: Q3 2026.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
          {kpis.map((k) => (
            <div key={k.label}>
              <div className="font-display text-3xl md:text-4xl tracking-tight text-primary mb-2">
                {k.value}
              </div>
              <div className="text-[14px] text-foreground/85 leading-snug mb-1">
                {k.label}
              </div>
              {k.note && (
                <div className="text-[12px] text-muted-foreground">{k.note}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
));

PublicKpiStrip.displayName = "PublicKpiStrip";
export default PublicKpiStrip;
